import React from 'react';
import NSInput from 'bricks/NSInput/NSInput';
import NSSelect from 'bricks/NSSelect/NSSelect';
import AddressFields from './AddressFields';

interface DealFormProps {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  marketOptions: { label: string; value: string }[];
  constructionTypeOptions: { label: string; value: string }[];
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const DealForm: React.FC<DealFormProps> = ({
    formData,
    setFormData,
    marketOptions,
    constructionTypeOptions,
    handleChange,
}) => (
    <>
        <NSInput
            id="dealName"
            name="dealName"
            type="text"
            value={formData.dealName}
            onChange={handleChange}
            label="Deal name"
            required
            inputClassName="mb-2"
        />

        <AddressFields
            formData={formData}
            onChange={handleChange}
            onSelect={(key: keyof any, value: any) => setFormData((prev: typeof formData) => ({ ...prev, [key]: value }))}
            onToggleCoordinates={checked => setFormData((prev: typeof formData) => ({ ...prev, useCoordinates: checked }))}
        />

        <NSSelect
            id="market"
            name="market"
            value={
                marketOptions.find(
                    (option: { label: string; value: string }) => option.value === formData.market_id,
                ) || null
            }
            onChange={(selected: { label: string; value: string } | null) => setFormData((prev: typeof formData) => ({
                ...prev,
                market_id: selected?.value || '',
            }))}
            options={marketOptions}
            label="Market"
            required
            placeholder="Select"
            isClearable
            formClassName="mb-2"
        />

        <NSSelect
            id="constructionType"
            name="constructionType"
            value={constructionTypeOptions.find(option => option.value === formData.constructionTypeId) || null}
            onChange={selected => setFormData((prev: typeof formData) => ({ ...prev, constructionTypeId: selected?.value || '' }))}
            options={constructionTypeOptions}
            label="Construction type"
            required
            placeholder="Select"
            isClearable
            formClassName="mb-2"
        />
    </>
);

export default DealForm;
